/**
 * 复制文本到剪贴板，兼容Web端和微信小程序
 * @param {string} text - 要复制的文本内容
 * @returns {Promise} - 复制结果的Promise
 */
export const copy = text => {
  // Web端环境
  // 现代浏览器使用Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  // 降级方案：使用document.execCommand
  return new Promise((resolve, reject) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        resolve();
      } else {
        reject(new Error('复制失败'));
      }
    } catch (err) {
      reject(err);
    } finally {
      document.body.removeChild(textArea);
    }
  });
};
